'use strict';

module.exports = require('es5-ext/object/primitive-set')('key',
	'value', 'key+value');



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es6-map/lib/iterator-kinds.js
// module id = ../../../node_modules/es6-map/lib/iterator-kinds.js
// module chunks = 1